import * as Yup from 'yup'

// expiry date validation on text change
let textOldValue = ''
export const expiryDateValidationText = (text: string) => {
  // to detect cases of deletion
  textOldValue = textOldValue.length < text.length ? text : ''

  const slash = text.indexOf('/')
  const expiryDate = slash > -1 ? text.split('').splice(slash, 1) : text.split('')
  if (expiryDate.length > 1 && textOldValue.length > 1) {
    return Number(expiryDate[0]) > 1
      ? `0${expiryDate[0]}/${expiryDate[1]}${expiryDate[2] ? expiryDate[2] : ''}`
      : `${expiryDate[0]}${expiryDate[1]}/${expiryDate[2] ? expiryDate[2] : ''}${expiryDate[3] ? expiryDate[3] : ''}`
  }
  return text
}

export const isValidCardNumber = (value: string) => {
  let nCheck = 0
  let bEven = false

  if (value) {
    for (let n = value.length - 1; n >= 0; n -= 1) {
      const cDigit = value.charAt(n)
      let nDigit = parseInt(cDigit, 10)

      if (bEven) {
        nDigit *= 2
        if (nDigit > 9) {
          nDigit -= 9
        }
      }

      nCheck += nDigit
      bEven = !bEven
    }
  }
  return nCheck % 10 === 0
}

export const Name = Yup.string().min(2, 'Too Short Name!').max(50, 'Too Long Name!').required('Required')

export const Pincode = Yup.string()
  .length(6, 'Pincode is 6 digits')
  .min(6, 'Pincode is 6 digits')
  .required('Required')
  .test(
    'Test if its a valid',
    `Invalid Pincode.
Provide a valid area pincode.`,
    (value: string) => {
      return /^[1-9][0-9]{5}$/.test(value)
    },
  )

export const cardNumber = Yup.string()
  .min(15, 'Minimum 15 digits required')
  .required('Required')
  .test('Test if its a valid', 'Please enter a valid credit/debit card number', (value: string) => {
    return isValidCardNumber(value)
  })
export const TwoInputSchema = (field1: string, field2: string) =>
  Yup.string()
    .required('Required')
    .test('Test if its a valid', `Enter both ${field1} and ${field2}`, (value: any) => {
      const splitValues = value.split('_')
      if (splitValues.length === 1) {
        return splitValues[0] && splitValues[0] !== '0'
      }

      return splitValues[0] && splitValues[0] !== '0' && splitValues[1] && splitValues[1] !== '0'
    })

export const DOB = Yup.string()
  .required('Required')
  .matches(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/, 'Invalid Date of birth ')
export const Password = Yup.string()
  .required('Required')
  .matches(
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/,
    'Password should contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character',
  )
export const BankAccountNumber = Yup.string()
  .required('Required')
  .min(4, 'Too short Account Number!')
  /**
   * Indian Banks
   * https://www.rbi.org.in/scripts/PublicationReportDetails.aspx?ID=695#UAN
   */
  .matches(/^\d{9,18}$/, 'Only Numbers with length between 9-18 ')

// Specific to accountNumber as fieldname
export const confirmAccountNumber = Yup.string()
  .required('Required')
  .min(4, 'Too short Account Number!')
  /**
   * Indian Banks
   * https://www.rbi.org.in/scripts/PublicationReportDetails.aspx?ID=695#UAN
   */
  .matches(/^\d{9,18}$/, 'Only Numbers with length between 9-18 ')
  .oneOf([Yup.ref('accountNumber'), null], 'Passwords must match')

export const mobileNumber = Yup.string()
  .required('Required')
  .min(10, 'Mobile number must be 10 digits')
  .matches(/^\d{10}$/, 'Only 10 digit mobile number allowed')

export const mobileNumberOrName = Yup.string()
  .required('Required')
  .min(10, 'Mobile number must be 10 digits')
  .matches(/^\s*[0-9]{10}\s*$|[a-zA-Z]$/, '')

export const nickName = Yup.string().matches(/^[a-zA-Z0-9@!#$&*_]{0,25}$/, '')
export const amount = Yup.string()
  .required('Required')
  .min(1, 'Minimum allowed amount is ₹ 1')
  .matches(/^\d*(\.\d{1,4})?$/, '')

export const cvv = (count: number) =>
  Yup.string()
    .required('Required')
    .matches(new RegExp(`^\\d{${count}}$`), `Only ${count} digit number allowed`)

export const expiry = Yup.string()
  .min(4, 'Enter valid 4 digits')
  .required('Required')
  .matches(/^[0-1][0-9]\/[0-9][0-9]$/, 'Invalid Date (mm/yy). Starting digit must be 0 or 1 eg: 09/19')
  .test('Test if its a valid', 'Month should be less than or equal to 12 and greater than 0', (value: string) => {
    if (!value) {
      return false
    }
    const monthStr = value.split('/')[0]
    const month = Number(monthStr)
    if (isNaN(month)) {
      return false
    }
    const ret = month < 13 && month > 0
    return ret
  })
  .test('Test if its a future date', 'Expiry date should be future date', (value: string) => {
    if (!value) {
      return false
    }
    const monthStr = value.split('/')[0]
    const yearStr = value.split('/')[1]
    if (!monthStr || !yearStr) {
      return false
    }
    const month = Number(monthStr)
    const year = Number(`20${yearStr}`)
    if (isNaN(month) || isNaN(year)) {
      return false
    }
    const today = new Date()
    return year > today.getFullYear() || (year === today.getFullYear() && month > today.getMonth() + 1)
  })

export const email = Yup.string().email('Invalid email').required('Required')

export const addressLine = Yup.string().required('Required!').min(6, 'Too short address value!')

export const gstNumber = Yup.string()
  .required('Required!')
  .max(15, 'GST Id number should be 15 characters long')
  .matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/, 'Invalid GST Id number')

export const OTP = Yup.string().required('Required').min(6, '').max(6, 'OTP should be 6 digits long')
export const serviceProvider = Yup.string()
  .required('Required')
  .test('Test if its a valid', 'Enter both service provider and circle', (value: any) => {
    const splitValues = value.split('_')
    if (splitValues.length === 1) {
      return splitValues[0] && splitValues[0] !== '0'
    }

    return splitValues[0] && splitValues[0] !== '0' && splitValues[1] && splitValues[1] !== '0'
  })

export const dropDown = Yup.string().required('Required!')

export const checkboxValidation = Yup.string()
  .required('Required')
  .matches(/^true$/, 'please confirm T&Cs')

export const returnRegexSchema = (regex: RegExp, errorMsg = '') => {
  const returnRegex = Yup.string().test('Test if its a valid', errorMsg, (value: string) => {
    if (value === undefined) {
      return false
    }
    return regex.test(value)
  })

  return returnRegex
}

export const Regex = Yup.string().test(
  'Test if its a valid',
  `Invalid Pincode.
Provide a valid area pincode.`,
  (value: string) => {
    return /^[1-9][0-9]{5}$/.test(value)
  },
)
